import { useQuery } from 'react-query';

import { getIsServicePorviderExists } from 'api/clients/getIsServicePorviderExists';

const useGetClientsPestCompany = () => {
  return useQuery('serviceProviderExists', getIsServicePorviderExists, {
    refetchInterval: 15000,
    refetchOnWindowFocus: true,
  });
};

export default useGetClientsPestCompany;
